import Vue from 'vue'
import Invoice from './Invoice.vue'
import InvoiceHistory from './InvoiceHistory.vue'
import EditInvoice from './EditInvoice'
import PayInvoice from './PayInvoice'
import GenerateBoleto from './GenerateBoleto'
import Boleto from './Boleto.vue'
import Incentive from './Incentive'

const OpenInvoiceComponent = Vue.extend(Invoice)
const OpenHistoryInvoiceComponent = Vue.extend(InvoiceHistory)
const OpenEditInvoiceComponent = Vue.extend(EditInvoice)
const OpenPayInvoiceComponent = Vue.extend(PayInvoice)
const OpenGenerateBoletoComponent = Vue.extend(GenerateBoleto)
const OpenBoletoComponent = Vue.extend(Boleto)
const OpenIncetiveComponent = Vue.extend(Incentive)

export default {
  openInvoice (propsData) {
    return new OpenInvoiceComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openHistoryInvoice (propsData) {
    return new OpenHistoryInvoiceComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openEditInvoice (propsData) {
    return new OpenEditInvoiceComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openPayInvoice (propsData) {
    return new OpenPayInvoiceComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openGenerateBoleto (propsData) {
    return new OpenGenerateBoletoComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openBoleto (propsData) {
    return new OpenBoletoComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openIncentive (propsData) {
    return new OpenIncetiveComponent({
      el: document.createElement('div'),
      propsData
    })
  }
}



// WEBPACK FOOTER //
// ./client/components/finances/V2/invoice/invoice.js